/* eslint-disable react/no-array-index-key */
import { Box, Typography, Divider, IconButton, Chip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import useTemplateApis from "../hooks/use-template-apis";
import useAvailableApis from "../hooks/use-available-apis";
import useTemplateApisManagement from "../hooks/use-template-apis-management";
import TemplateApisTable from "./template-apis-table";
import TemplateApiFormDialog from "./template-api-form-dialog";
import TemplateApiDeleteDialog from "./template-api-delete-dialog";

interface TemplateApisProps {
  templateId: number | null;
}

const TemplateApis = ({ templateId }: TemplateApisProps) => {
  const { templateApis, isLoading, mutate } = useTemplateApis(templateId);
  const { availableApis, isLoading: isLoadingAvailableApis } =
    useAvailableApis();

  const {
    openDialog,
    selectedEndpoint,
    isSaving,
    setSelectedEndpoint,
    setSelectedApiId,
    handleOpenDialog,
    handleCloseDialog,
    handleSave,
    deleteConfirmOpen,
    apiToDelete,
    isDeleting,
    handleDelete,
    handleConfirmDelete,
    handleCancelDelete,
  } = useTemplateApisManagement({
    templateId: templateId ?? 0,
    mutate,
  });

  const apiCount = templateApis?.length ?? 0;

  const handleEndpointChange = (endpoint: string, apiId: number) => {
    setSelectedEndpoint(endpoint);
    setSelectedApiId(apiId);
  };

  return (
    <>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mt: 3,
            mb: 0.5,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Typography variant="body2" fontWeight={600}>
              API&apos;s
            </Typography>
            <Chip
              label={`${apiCount} active`}
              size="small"
              color="primary"
              variant="outlined"
              sx={{ height: 20, fontSize: "0.7rem" }}
            />
          </Box>
          <IconButton
            size="small"
            color="success"
            onClick={handleOpenDialog}
            disabled={isLoading || !templateId}
            aria-label="Add API"
          >
            <AddIcon fontSize="small" />
          </IconButton>
        </Box>
        <Divider sx={{ mb: 1 }} />

        <Box
          sx={{
            border: 1,
            borderColor: "grey.300",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <TemplateApisTable
            templateApis={templateApis ?? []}
            onDelete={handleDelete}
            isLoading={isLoading}
          />
        </Box>
      </Box>

      <TemplateApiFormDialog
        open={openDialog}
        availableApis={availableApis ?? []}
        selectedEndpoint={selectedEndpoint}
        isSaving={isSaving}
        isLoadingApis={isLoadingAvailableApis}
        onClose={handleCloseDialog}
        onSave={handleSave}
        onEndpointChange={handleEndpointChange}
      />

      <TemplateApiDeleteDialog
        open={deleteConfirmOpen}
        api={apiToDelete}
        isDeleting={isDeleting}
        onCancel={handleCancelDelete}
        onConfirm={handleConfirmDelete}
      />
    </>
  );
};

export default TemplateApis;
